export default "__VITE_ASSET__B58m6o84__"